import {SimpleEditor} from "./SimpleEditor.js";
import {Temp} from "../utils/Temp.js";
import {Suggest} from "../suggest/Suggest.js";
import {Propagator} from "../suggest/Propagator.js";

export class SuggestEditor extends SimpleEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions, titleMember, suggester, propagator, serverOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);

		if (typeof titleMember !== 'undefined') this.titleMember = titleMember;
		else this.titleMember = widgetOptions.titleMember;
		if (typeof suggester !== 'undefined') this.suggester = suggester;
		else this.suggester = widgetOptions.suggester;
		if (typeof propagator !== 'undefined') this.propagator = propagator;
		else this.propagator = widgetOptions.propagator;
		if (typeof serverOptions !== 'undefined') this.serverOptions = serverOptions;
		else this.serverOptions = widgetOptions.serverOptions;
	}

	withTitleMember(titleMember) { this.titleMember = titleMember; return this; }
	withSuggester(suggester) { this.suggester = suggester; return this; }
	withPropagator(propagator) { this.propagator = propagator; return this; }
	withServerOptions(ops) { this.serverOptions = ops; return this; }

	rebuild() {
		this.root = Temp.tag('div');
		this.root.css('display', 'inline');
		this.widget = Temp.text(this.options);
		this.widget.addClass('suggfield');
		this.root.append(this.widget);
		this.results = Temp.tag('div', {clazz: 'results'});
		this.root.append(this.results);
		let s = new Suggest(this.widget, this.results, this.suggester, null, new SuggestEditorPropagator(this, this.propagator), this.options, this.serverOptions);
	}
}

class SuggestEditorPropagator extends Propagator {
	constructor(editor, propagatingFunction) {
		super();
		this.editor = editor;
		this.propagator = propagatingFunction;
	}

	get id() {
		return this.editor.fromData(this.editor.data);
	}

	set id(value) {
		this.editor.data = this.editor.toData(value);
	}

	get title() {
		if (this.editor.titleMember) return this.editor.obj === null ? null : this.editor.obj[this.editor.titleMember];
		return "";
	}

	set title(value) {
		if (this.editor.titleMember && this.editor.obj !== null) this.editor.obj[this.editor.titleMember] = value;
	}

	propagate(data) {
		if (typeof this.propagator === 'function') this.propagator(data, this.editor);
	}
}
